import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Settings from "@material-ui/icons/Settings";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Toast from 'views/Toast/Toast';
import { CallApi } from 'utils/Request';
import axios from 'axios';
import { api_url } from 'redux/config.js';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  ...regularFormsStyle,
  settingRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 0',
    borderBottom: '1px solid #eee',
  },
  settingLabel: {
    fontWeight: 'bold',
    fontSize: '14px',
    minWidth: '250px',
  },
  settingDesc: {
    color: '#999',
    fontSize: '12px',
    marginTop: '4px',
  },
  settingInput: {
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    width: '200px',
    marginRight: '10px',
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  switchOn: {
    backgroundColor: '#4caf50',
    color: 'white',
    border: 'none',
    padding: '8px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  switchOff: {
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    padding: '8px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
}));

function AppSettingsPage(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [settings, setSettings] = useState([]);
  const [editValues, setEditValues] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const state = require('redux/store').store.getState();
      const token = state.user.token;
      const response = await axios.get(api_url + 'app/settings', { headers: { Authorization: 'Bearer ' + token } });
      const res = response.data;
      if (response.success) {
        setSettings(response.data);
        const vals = {};
        response.data.forEach(s => { vals[s.setting_key] = s.setting_value; });
        setEditValues(vals);
      }
    } catch (err) {
      Toast(400, 'Error loading settings');
    }
    setLoading(false);
  };

  const saveSetting = async (key) => {
    try {
      const response = await CallApi({
        method: 'put',
        url: 'app/settings',
        data: { setting_key: key, setting_value: editValues[key] }
      });
      if (response.success) {
        Toast(200, 'Setting saved!');
        loadSettings();
      } else {
        Toast(400, response.error);
      }
    } catch (err) {
      Toast(400, 'Error saving setting');
    }
  };

  const toggleSetting = async (key) => {
    const newValue = editValues[key] === 'true' ? 'false' : 'true';
    setEditValues({ ...editValues, [key]: newValue });
    try {
      const response = await CallApi({
        method: 'put',
        url: 'app/settings',
        data: { setting_key: key, setting_value: newValue }
      });
      if (response.success) {
        Toast(200, 'Setting saved!');
        loadSettings();
      } else {
        Toast(400, response.error);
      }
    } catch (err) {
      Toast(400, 'Error saving setting');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Settings />
            </CardIcon>
            <h4 style={{ color: '#333', fontWeight: 'bold' }}>App Settings</h4>
          </CardHeader>
          <CardBody>
            {settings.map(setting => (
              <div key={setting.setting_key} className={classes.settingRow}>
                <div style={{ flex: 1 }}>
                  <div className={classes.settingLabel}>{setting.setting_key.replace(/_/g, ' ').toUpperCase()}</div>
                  <div className={classes.settingDesc}>{setting.description}</div>
                </div>
                <div>
                  {setting.setting_value === 'true' || setting.setting_value === 'false' ? (
                    <div className={classes.switchContainer}>
                      <button
                        className={editValues[setting.setting_key] === 'true' ? classes.switchOn : classes.switchOff}
                        onClick={() => toggleSetting(setting.setting_key)}
                      >
                        {editValues[setting.setting_key] === 'true' ? 'ON' : 'OFF'}
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        className={classes.settingInput}
                        type="text"
                        value={editValues[setting.setting_key] || ''}
                        onChange={(e) => setEditValues({ ...editValues, [setting.setting_key]: e.target.value })}
                      />
                      <Button color="success" size="sm" onClick={() => saveSetting(setting.setting_key)}>
                        Save
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default AppSettingsPage;
